<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- BADGES -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              BADGES
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-10">
                <p>Badge'ler konulduklari öğenin yanında dikey olarak ortalı dururlar. 'Padding' veya 'Margin' ile konuşlandırılmamalıdır.</p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-2">
                <h2 class="with-badge">
                  Örnek Yazı
                  <span class="badge badge-tangerine xxs ml-2">YENİ</span>
                </h2>
              </div>
              <div class="col-2">
                <p class="lg with-badge">
                  Örnek Yazı
                  <span class="badge badge-tangerine xxs ml-2">YENİ</span>
                </p>
              </div>
              <div class="col-2">
                <p class="small bold with-badge">
                  Örnek Yazı
                  <span class="badge badge-tangerine xxs ml-2">YENİ</span>
                </p>
              </div>
              <div class="col-2">
                <p class="xxs bold with-badge">
                  Örnek Yazı
                  <span class="badge badge-tangerine xxs ml-2">YENİ</span>
                </p>
              </div>
            </b-row>
            <b-row>
              <div class="col-10">
                <h2 class="bold mt-4">
                  Rounded Style
                </h2>
                <span class="badge badge-rounded mt-3">Ankara / Mamak</span>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Badge',
  data() {
    return {};
  },
  computed: {},
};
</script>
